// extracted by mini-css-extract-plugin
export default {"bar":"InfoBar_bar__XQt4t","iconHolder":"InfoBar_iconHolder__Xn4D+","title":"InfoBar_title__QcI3G","description":"InfoBar_description__cmL3F"};